import React, { useState } from "react";
import {
  setRefetch,
  setRefetchKey,
} from "../../../../features/global/globalSlice";
import { Tabs } from "antd";
import { useDispatch } from "react-redux";
import Boq from "./Boq";
import ProjectDetailsSub from "./ProjectDetailsSub";

function BoqList({ handleExpand, expand, handleExpandDetails, expandDetails }) {
  const dispatch = useDispatch();
  const [active, setactive] = useState("1");

  async function refetching(activeKey) {
    setactive(activeKey);
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(activeKey));
  }

  const tabConfigurations = [
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Details</span>
        </span>
      ),
      key: "1",
      children: (
        <ProjectDetailsSub
          handleExpand={handleExpandDetails}
          expand={expandDetails}
        />
      ),
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" ">BoQ</span>
        </span>
      ),
      key: "2",
      children: <Boq handleExpand={handleExpand} expand={expand} />,
    },
  ];

  return (
    <div className="white_card w-full flex-1">
      <Tabs
        items={tabConfigurations}
        defaultActiveKey="1"
        activeKey={active}
        onChange={refetching}
        className="activity-tab-wrap activity-tab activity-bar"
      />
    </div>
  );
}

export default BoqList;
